export const setRecipientsContact = (contacts) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_SELECTED_CONTACTS',
      data: {
        selectedContacts: contacts,
        totalSelectedContacts: contacts.length
      }
    })
  }
}

export const removeAllContacts = () => {
  return (dispatch) => {
    dispatch({
      type: 'CLEAR_SELECTED_CONTACTS'
    })
  }
}
